'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.Canvas = Canvas;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _NonReact = require('./NonReact');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createCanvasDelegate(Delegate) {
  return function () {
    function CanvasDelegate() {
      var _this = this;

      _classCallCheck(this, CanvasDelegate);

      this.runUpdate = function (time) {
        _this.delegate.update(time - _this.prevTime);
        _this.prevTime = time;
        window.requestAnimationFrame(_this.runUpdate);
      };
    }

    _createClass(CanvasDelegate, [{
      key: 'create',
      value: function create(el, props) {
        var _this2 = this;

        var canvasEl = document.createElement('canvas');
        canvasEl.width = props.width;
        canvasEl.height = props.height;
        el.appendChild(canvasEl);

        this.delegate = new Delegate(canvasEl, props);

        window.requestAnimationFrame(function (time) {
          _this2.prevTime = time;
          _this2.runUpdate(time);
        });
      }
    }, {
      key: 'update',
      value: function update(el, props) {
        if (this.delegate.updateprops) this.delegate.updateProps(props);
      }
    }]);

    return CanvasDelegate;
  }();
}

function Canvas(props) {
  return _react2.default.createElement(_NonReact.NonReact, _extends({
    className: 'props'
  }, props, {
    delegate: createCanvasDelegate(props.delegate)
  }));
}


//////////////////
// WEBPACK FOOTER
// ./~/dooh-react-utils/dist/Canvas.js
// module id = 134
// module chunks = 0